import React, { useState, useRef } from "react";
import { ClickAwayListener } from "@mui/material";

import MenuItem from "./MenuItem";

import { NestedMenu, NestedMenuContent } from "./styles";

const DropdownMenu = ({
  name,
  isAbsolute,
  imageUrl,
  items,
  pageUrl,
  cdnUrl,
  gotoPage,
  onLogout,
  closeMenu,
  openSubmenuId,
  onSubmenuToggle,
  submenuId,
}) => {
  const nestedMenuRef = useRef(null);
  const commonProps = { cdnUrl, gotoPage, isAbsolute, closeMenu };

  const hasNestedItems = Array.isArray(items) && items.length > 0;
  const isNestedOpen = openSubmenuId === submenuId;

  const handleNestedClose = () => {
    if (onSubmenuToggle) {
      onSubmenuToggle(null);
    }
  };

  const handleToggleNested = (e) => {
    e.stopPropagation();
    if (onSubmenuToggle) {
      // If opening the menu (was closed, now opening), reset any nested submenu states
      if (!isNestedOpen) {
        // Reset nested submenu states by re-rendering the nested MenuGroup
        setNestedMenuKey(prev => prev + 1);
      }
      onSubmenuToggle(isNestedOpen ? null : submenuId);
    }
  };

  // Add state to force re-render of nested menu when needed
  const [nestedMenuKey, setNestedMenuKey] = useState(0);

  const handleNestedContentClick = (e) => {
    e.stopPropagation();
  };

  return hasNestedItems ? (
    <ClickAwayListener onClickAway={handleNestedClose}>
      <NestedMenu 
        key={name}
        ref={nestedMenuRef}
        onClick={handleToggleNested}
        isOpen={isNestedOpen}
      >
        <MenuItem
          name={name}
          imageUrl={imageUrl}
          {...commonProps}
          isNested
          onLogout={onLogout}
        />
        <NestedMenuContent isOpen={isNestedOpen} onClick={handleNestedContentClick}>
          <MenuGroup 
            key={nestedMenuKey}
            items={items} 
            {...commonProps} 
            onLogout={onLogout} 
            closeMenu={closeMenu}
          />
        </NestedMenuContent>
      </NestedMenu>
    </ClickAwayListener>
  ) : (
    <MenuItem
      name={name}
      imageUrl={imageUrl}
      pageUrl={pageUrl}
      onLogout={onLogout}
      {...commonProps}
    />
  );
};

const MenuGroup = ({ items, cdnUrl, gotoPage, isAbsolute, onLogout, closeMenu }) => {
  const [openSubmenuId, setOpenSubmenuId] = useState(null);

  const handleSubmenuToggle = (submenuId) => {
    setOpenSubmenuId(submenuId);
  };

  return items.map((item, index) => (
    <DropdownMenu
      {...item}
      isAbsolute={item.isAbsolute || false}
      key={item.name || index}
      submenuId={`${item.name}-${index}`}
      cdnUrl={cdnUrl}
      gotoPage={gotoPage}
      onLogout={onLogout}
      closeMenu={closeMenu}
      openSubmenuId={openSubmenuId}
      onSubmenuToggle={handleSubmenuToggle}
    />
  ));
};

const Menu = ({ cdnUrl, gotoPage, data, onLogout, closeMenu }) => (
  <MenuGroup 
    items={data} 
    cdnUrl={cdnUrl} 
    gotoPage={gotoPage} 
    onLogout={onLogout} 
    closeMenu={closeMenu} 
  />
);

export default Menu;
